import { ActionType, LoadingState } from '../types'
import {
  GetNotificationsPayload,
  MarkAsReviewedPayload,
  UserNotification,
} from './types'

export type GetNotifications = ActionType<GetNotificationsPayload>
export type MarkAsReviewed = ActionType<MarkAsReviewedPayload>
export type GetNotificationsSuccess = ActionType<UserNotification[]>
export type GetNotificationsFailure = ActionType<string>
export type MarkAsReviewedSuccess = ActionType<number>
export type MarkAsReviewedFailure = ActionType<string>
export type SetUnreadCount = ActionType<number>
export type SetLoading = ActionType<LoadingState>
export type SetBundleDrawerOpen = ActionType<boolean>

export enum NotificationType {
  ORDER_CREATED = 1,
  ORDER_SHIPPED = 2,
  ORDER_DELIVERED = 3,
  PAYMENT_RECEIVED = 4,
  ITEM_SOLD = 5,
  SHIPPING_LABEL_NEEDED = 6,
  SYSTEM_NOTIFICATION = 7,
  PAYMENT_CANCELLED = 8,
}

export type NotificationError = {
  code: number
  message: string
}
